'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
require('react');
const components_display_Heading_Heading = require('../Heading/Heading.cjs.js');
require('../../../utils/heading-level-context/HeadingLevelContext.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableTitleArea", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: var(--zds-space-20);
    align-items: center;
    background-color: ${theme_Colors.Colors.PrimeWhite};
  `,
  title: react.css`
    ${styleMixins_reset.boxSizing};
    color: ${theme_Colors.Colors.TextDefault};
    ${theme_Typography.Typography.SectionHeader};
  `
});
const TableTitle = (props) => {
  return react.jsx(components_display_Heading_Heading.Heading, { css: Styles.title }, props.children);
};
const TableTitleArea = ({ children, kind = "standard" }) => {
  return react.jsx("header", { css: Styles.root, "data-kind": kind, "data-zds": true }, children);
};

exports.TableTitle = TableTitle;
exports.TableTitleArea = TableTitleArea;
//# sourceMappingURL=TableTitleArea.cjs.js.map
